export type CalendarModule =
  | 'trade'
  | 'transportation'
  | 'production'
  | 'compliance'
  | 'finance'
  | 'inventory';

export type CalendarEventKind = 'point' | 'range';

export type CalendarEventSource =
  | 'booking'
  | 'load'
  | 'salesOrder'
  | 'route'
  | 'driverCertification'
  | 'workOrder'
  | 'inboundTolling'
  | 'outboundTolling'
  | 'dispatchRecord'
  | 'invoice'
  | 'bill'
  | 'inventoryMovement';

export interface CalendarEvent {
  id: string;
  title: string;
  start: string;
  end?: string;
  allDay: boolean;
  module: CalendarModule;
  source: CalendarEventSource;
  kind: CalendarEventKind;
  entityUrl: string;
  facilityId?: string;
  facilityName?: string;
  status?: string;
  meta?: Record<string, unknown>;
}

export const ALL_MODULES: CalendarModule[] = [
  'trade',
  'transportation',
  'production',
  'compliance',
  'finance',
  'inventory',
];

export interface ModuleState {
  loading: boolean;
  error: boolean;
  truncated: boolean;
  totalCount: number;
}
